import { createAction, props } from '@ngrx/store';
// import { Pharmacy } from 'src/models/module-wise/user/patient';

// TODO: Add Interface

export const paginatePharmacies = createAction(
  '[ PHARMACY ] Paginating'
);

export const loadPharmacies = createAction(
  '[ PHARMACY ] Load Pharmacy',
  props<{ payload: any[], totalDocuments: number }>()
);

export const editPharmacy = createAction(
  '[ PHARMACY ] Edit Pharmacy',
  props<{ payload: any | { status: string, _id: string } }>()
);

export const removePharmacies = createAction(
  '[ PHARMACY ] Delete Pharmacy',
  props<{ payload: string[] }>()
);

export const removeAllPharmacies = createAction(
  '[ PHARMACY ] Remove All Pharmacy'
);
